import React, { useState, useRef, useEffect } from "react";
import { SmallLogoIcon } from "../Icons/SmallLogoIcon";
import { useNavigate } from "react-router-dom";

const NeptuneAccessDropdown = ({ onRequestDemo }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = () => {
    navigate("/request-demo"); // Route to the new page
    setIsOpen(false);

    // Call the callback to close mobile drawer if provided
    if (onRequestDemo) {
      onRequestDemo();
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <div
        className="flex ml-0 lg:ml-4 xl:ml-0 items-center text-white font-['Poppins'] justify-center px-2 py-1 min-h-[26px] gap-[4px] bg-[#0769e9]  rounded-md font-medium text-[13px] border-2 border-[#016FFC] hover:bg-[#016FFC] cursor-pointer w-full sm:w-auto"
        onClick={handleOptionClick}
      >
        <span>
          <SmallLogoIcon />
        </span>
        <span className="hidden pl-1 xl:block font-['Poppins'] font-[14px]">
          Request Demo
        </span>
        <span className="block xl:hidden font-[14px] pl-1">Request Demo</span>
        {/* <span className="ml-1 text-white text-xs">
          <ArrowDown />
        </span> */}
        {/* <span className="ml-1 text-white text-xs">
          <ArrowDown />
        </span> */}
      </div>
      {isOpen && (
        <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 bg-white shadow-lg rounded-lg overflow-hidden z-10 w-full sm:w-auto min-w-[240px]">
          <div className="py-1">
            <div
              className="px-4 py-2.5 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 cursor-pointer transition-colors duration-150"
              onClick={handleOptionClick}
            >
              Neptune 2.0 Access Demo #1
            </div>
            {/* <div
              className="px-4 py-2.5 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 cursor-pointer transition-colors duration-150"
              onClick={handleOptionClick}
            >
              Neptune 2.0 Access Demo #2
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default NeptuneAccessDropdown;
